import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import CaseTracker from '@paypalcorp/disputes-case-tracker';
import Trackers from '@paypalcorp/cs-help-trackers';

import { MppHeaderComponent, MppFooterComponent } from './MppHeaderFooter';
// Component
import SessionHandler from '../../contactUs/containers/SessionHandler';
import HeroModuleSession from '../../contactUs/containers/HeroModule';
import NewHeroModuleSession from '../../common/HeroSectionNoLinkHome';
import ContactOptionsLinksFooter from '../../contactUs/components/ContactOptionsLinksFooter';
import AlertsContainer from '../../contactUs/containers/Alerts';
import NewSearchBox from '../../contactUs/containers/NewSearchBox';
// Container
import NavHome from '../containers/NavHome';
import ModalContainer from '../../contactUs/containers/ModalContainer';
import ChatInEligibleModalContainer from '../../contactUs/containers/ChatInEligibilityModalContainer';
import DisputeAlert from '../../contactUs/containers/DisputeAlert';
import IcfContainer from '../containers/IcfContainer';
import UrlResources from '../constants/UrlResources';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import ContactCardContainer from './contactOptionCards/ContactCardContainer';
import NaaAlert from '../../common/NaaAlert';
import { getCurrentRouteResourceName } from '../../lib/location-helper';
import { DISPUTE_CASE } from '../../contactUs/constants/PropTypesShapes';
import CovidAlertModalContainer from '../../contactUs/containers/CovidAlertModalContainer';
import { isTrackersEnabledInHome } from '../../lib/covidHelper';
import { isCsHelpRefundTrackerEnabled } from '../../lib/TrackersHelper';
import { pageNames } from '../../lib/page-name-identifiers';
import TrackerAlerts from '../../common/trackerAlerts';
import BrexitComplaintsContainer from '../containers/BrexitComplaintsContainer';
import OmniChannelPromptContainer from '../containers/OmniChannelPromptContainer';
import { getTopSearchReason } from '../actions/actions-top-contact-reason';
import { getComplaintsPageInfo } from '../../lib/globalHelper';
import ContactOptionsFooter from '../../contactUs/components/complaintsEnhancedFooter/ContactOptionsLinksFooter';

const labels = {
  header: i18n.message('smarthelp/home.home.back.icf.articles'),
  homeHeader: i18n.message('smarthelp/heroSection.home.heroModule.headerLabel'),
};

class App extends Component {
  static renderRefundTracker() {
    if (isCsHelpRefundTrackerEnabled()) {
      return (
        <Trackers
          type="refunds"
          componentName="smarthelpnodeweb"
          fptiOptions={{
            page: pageNames.refundsTrackerHome.pageName,
            pgrp: pageNames.refundsTrackerHome.pageGroupName,
          }}
          collapseAll
        />
      );
    }

    return (<div className="home-refund-tracker"><div id="refund-help" name="home" /></div>);
  }

  constructor(props) {
    super(props);
    this.sidebarEl = this.sidebarEl.bind(this);
    this.mainContainerEl = this.mainContainerEl.bind(this);
    this.renderSearch = this.renderSearch.bind(this);
  }

  sidebarEl() {
    const { sideBar } = this.props;
    return (
      <div className="side-bar side-bar__grid">
        { sideBar }
      </div>
    );
  }

  mainContainerEl() {
    const { mainContainer } = this.props;
    return (
      <div id="main-container" className="main-container main-container__grid" tabIndex="0" aria-label="">
        <div className="main-container-contents">
          { mainContainer }
        </div>
      </div>
    );
  }

  renderDisputeTracker() {
    const { disputes } = this.props;
    if (Array.isArray(disputes) && disputes.length) {
      return (
        <div className="home-dispute-tracker">
          <CaseTracker
            flow="smarthelp:home"
            fptiOptions={{
              page: 'main:help:smart::dispute-tracker:::',
              pgrp: 'main:help:smart::home',
            }}
          />
        </div>
      );
    }
    return <div />;
  }

  // TODO: Remove this logic during covid -19 clean up
  renderHomePageTrackers() {
    const pathName = this.props.location && this.props.location.pathname;
    const isHomePage = pathName && pathName === `/${UrlResources.HOME}`;
    // Remote Config Check for Covid-19 Enable tracker
    if (!isTrackersEnabledInHome() || !isHomePage) {
      return <div />;
    }
    return (
      <div className="trackers-home">
        {this.renderDisputeTracker()}
        {App.renderRefundTracker()}
      </div>
    );
  }

  renderHomePage() {
    const pathName = this.props.location && this.props.location.pathname;
    const icfGuides = pathName.indexOf(UrlResources.PAYPALGUIDE) !== -1;
    const isHomePage = pathName && pathName === `/${UrlResources.HOME}`;

    // Check for complaints path
    const complaintsPath = (pathName && pathName.split('/') && pathName.split('/').pop() === UrlResources.COMPLAINTS);

    if (complaintsPath) {
      // getting the common questions topic name from remote config
      const commonQuestionsTopic = (getComplaintsPageInfo() && getComplaintsPageInfo().commonQuestionsTopic) || 'HELPHUB_TOPCONTACT_COMPLAINTS';

      // triggering common questions API
      this.props.getTopSearchReason(commonQuestionsTopic, true);

      // Add fpti tracker id
      return (
        <div>
          <AlertsContainer />
          <ModalContainer FPTITrackerId="complaintsIntermediatePage" />
          <BrexitComplaintsContainer />
          <ContactOptionsFooter />
        </div>
      );
    } if (icfGuides) {
      // checking for icf or guide path to render only icfcontainer
      return (
        <div>
          <AlertsContainer />
          <IcfContainer />
          <ContactOptionsLinksFooter />
        </div>
      );
    }
    return (
      <div className="page-main-container" role="main">
        {Page.isLoggedIn() ? <TrackerAlerts /> : <div />}
        <DisputeAlert />
        <AlertsContainer />
        {isHomePage && <OmniChannelPromptContainer />}
        {isHomePage && <ContactCardContainer />}
        {Page.isLoggedIn() ? this.renderHomePageTrackers() : null}
        <NavHome />
        <ModalContainer FPTITrackerId="articleintermediatePage" />
        <ChatInEligibleModalContainer />
        <div className="page-body-container">
          {this.sidebarEl()}
          {' '}
          {this.mainContainerEl()}
        </div>
        <ContactOptionsLinksFooter />
      </div>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  renderSearch() {
    const FPTIId = Page.getFPTIPageId();
    const SearchBox = Page.isSearchTopicDisplay()
      ? (<h1 className="hero-search-header-replacement">{labels.header}</h1>)
      : (<NewSearchBox FPTIId={FPTIId} />);
    return (
      <div className="new-search-box-container">
        {SearchBox}
      </div>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  renderNewHeroModule() {
    if (!Page.isContactUsPage()) {
      return (
        <NewHeroModuleSession>
          <div className="homepage-search">
            <div className="header-text">
              <h1>{labels.homeHeader}</h1>
            </div>
            {this.renderSearch()}
          </div>
        </NewHeroModuleSession>
      ); // New Hero Module
    }
    return <HeroModuleSession />; // Existing Hero Module
  }

  // Complaints Page Header Image
  renderBrexitHeaderIcon() {
    const pathName = this.props.location && this.props.location.pathname;

    // Check for complaints path
    const complaintsPath = (pathName && pathName.split('/') && pathName.split('/').pop() === UrlResources.COMPLAINTS);

    // if its not complaints path ont load the complaints page header Image
    if (!complaintsPath) {
      return <div />;
    }

    const complaintsTextInfo = getComplaintsPageInfo();

    return (
      <div>
        <div className="brexit-complaints-page__intro-icon" />
        <div className="brexit-complaints-page__icon_text">
          <div className="brexit-complaints-page__icon_text__complaints-header">
            <h3 className="brexit-complaints-page__icon_text__complaints-header__intro-topic">{complaintsTextInfo.introTopic}</h3>
            <h5 className="brexit-complaints-page__icon_text__complaints-header__country">{complaintsTextInfo.complaintsCountry}</h5>
          </div>
          <p className="brexit-complaints-page__icon_text__complaints-intro">{complaintsTextInfo.complaintsIntro}</p>
        </div>
      </div>
    );
  }

  render() {
    const pathName = getCurrentRouteResourceName(this.props.location);
    return (
      <div>
        <MppHeaderComponent />
        <div className="vx_mainContent">
          <SessionHandler />
          {this.renderNewHeroModule()}
          {this.renderBrexitHeaderIcon()}
          <div className="page-main-container" role="main">
            {Page.isLoggedIn() ? <NaaAlert pathName={pathName} /> : <div />}
            <CovidAlertModalContainer location={this.props.location} />
            {this.renderHomePage()}
          </div>
        </div>
        <MppFooterComponent />
      </div>
    );
  }
}

App.propTypes = {
  sideBar: PropTypes.element.isRequired,
  mainContainer: PropTypes.element.isRequired,
  location: PropTypes.string.isRequired,
  disputes: PropTypes.shape(DISPUTE_CASE),
  getTopSearchReason: PropTypes.func.isRequired,
};

App.defaultProps = {
  disputes: [],
};

function mapStateToProps(state) {
  return {
    location: state.location,
    disputes: state.disputeTransactions.disputes,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getTopSearchReason }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
